'use client';

import { useRef, useEffect, useState, createContext, useContext } from 'react';

import { cn } from '@/utils/cn';

const StaggerContext = createContext(false);

const FadeInStagger = ({
  children,
  className,
}: React.PropsWithChildren<{ className?: string }>) => {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: '-60px 0px' },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <StaggerContext.Provider value={visible}>
      <div ref={ref} className={className}>
        {children}
      </div>
    </StaggerContext.Provider>
  );
};

export { FadeInStagger };

const FadeInItem = ({
  children,
  className,
  index = 0,
}: React.PropsWithChildren<{ className?: string; index?: number }>) => {
  const visible = useContext(StaggerContext);

  return (
    <div
      className={cn(
        'transition-[opacity,transform] duration-500 ease-out',
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5',
        className,
      )}
      style={{ transitionDelay: `${index * 0.12}s` }}
    >
      {children}
    </div>
  );
};

export { FadeInItem };
